import TournamentEdit from './TournamentEdit';

export default TournamentEdit;
